// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__4J7g0","buttons":"Footer_buttons__CMQi5"};